// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/calendar/style/index.less
// module id = 1001
// module chunks = 1